import { gql } from '@apollo/client';

const USER_BASIC_FRAGMENT = gql`
  fragment UserBasicFragment on User {
    id
    name
    volcanoClientId
    email
    isAdmin
    isClient
    clientRole
    disabled
    hasWebPanelAccount
    client {
      id
    }
  }
`;

const DRIVER_BASIC_FRAGMENT = gql`
  fragment DriverBasicFragment on Driver {
    id
    name
    phone
    email
    status
    alternatePhone
    communicationLocale
    firebaseId
    hasLoginCredentials
    loginEnabled
    notificationsToken
    loginMethod
    volcanoDriverId
    volcanoEmail
    inPrisma
    inVolcano
    profilePicURI
    drivingCompany {
      name
      email
      phone
      volcanoId
      id
    }
  }
`;

export const GET_MATCHING_PRISMA_USER_OR_DRIVER = gql`
  ${USER_BASIC_FRAGMENT}
  ${DRIVER_BASIC_FRAGMENT}
  query GET_MATCHING_PRISMA_USER_OR_DRIVER {
    userOrDriver {
      __typename
      ... on User {
        ...UserBasicFragment
      }
      ... on Driver {
        ...DriverBasicFragment
      }
    }
  }
`;

export const GET_ME = gql`
  ${USER_BASIC_FRAGMENT}
  query GetMe {
    user {
      ...UserBasicFragment
    }
  }
`;

export const GET_USER_BY_EMAIL = gql`
  ${USER_BASIC_FRAGMENT}
  query GetUserByEmail($email: String!) {
    userByEmail(email: $email) {
      ...UserBasicFragment
    }
  }
`;

export const ON_UPDATE_ME = gql`
  ${USER_BASIC_FRAGMENT}
  subscription onUpdateMe {
    onUpdateMe {
      ...UserBasicFragment
    }
  }
`;
